/**
 * Hydrate storefront from Staff Admin store settings.
 * Source: https://minnies-newsletter-api.nic-58f.workers.dev/api/store-settings
 * Liquid renders safe defaults; this script applies the latest saved admin values.
 */
(function () {
  var ENDPOINT = 'https://minnies-newsletter-api.nic-58f.workers.dev/api/store-settings';

  function setText(el, text) {
    if (!el) return;
    el.textContent = text == null ? '' : String(text);
  }

  function setHref(el, href) {
    if (!el || !href) return;
    el.setAttribute('href', href);
  }

  function phoneHref(phone) {
    var digits = String(phone || '').replace(/[^\d]/g, '');
    if (digits.length === 10) digits = '1' + digits;
    return digits ? 'tel:+' + digits : '';
  }

  function nextElementSibling(node) {
    var n = node ? node.nextSibling : null;
    while (n && n.nodeType === 3) n = n.nextSibling;
    return n;
  }

  function setSocial(el, url) {
    if (!el) return;
    if (url) {
      setHref(el, url);
      el.hidden = false;
      el.removeAttribute('aria-hidden');
    } else {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
    }
  }

  function syncSocialBreaks(follow) {
    if (!follow) return;
    Array.prototype.slice.call(follow.querySelectorAll('a[data-minnies-social-row]')).forEach(function (a) {
      var br = nextElementSibling(a);
      if (a.hidden) {
        if (br && br.nodeName === 'BR') br.remove();
      } else if (!br || br.nodeName !== 'BR') {
        a.insertAdjacentHTML('afterend', '<br>');
      }
    });
  }

  function applyReviewMode(settings) {
    var roots = document.querySelectorAll('[data-minnies-review-root]');
    var googleUrl = (settings && settings.google_review_url) || '';
    var label = (settings && settings.google_review_button_label) || 'Leave a review on Google';
    var intro = (settings && settings.google_review_intro) || '';

    roots.forEach(function (root) {
      var mode = root.getAttribute('data-review-display') || 'form';
      if (mode === 'form') return;

      var block = root.querySelector('[data-minnies-google-block]');
      var formWrap = root.querySelector('[data-minnies-review-form]');
      var missing = root.querySelector('[data-minnies-google-missing]');
      var btn = root.querySelector('[data-minnies-google-review]');
      var introEl = root.querySelector('[data-minnies-google-intro]');
      var heading = root.querySelector('[data-minnies-google-heading]');

      if (googleUrl) {
        if (block) block.hidden = false;
        if (formWrap) formWrap.hidden = true;
        if (missing) missing.hidden = true;
        if (btn) {
          setHref(btn, googleUrl);
          setText(btn, label);
          btn.setAttribute('target', '_blank');
          btn.setAttribute('rel', 'noopener noreferrer');
        }
        if (introEl) {
          if (intro) {
            introEl.hidden = false;
            setText(introEl, intro);
          } else {
            introEl.hidden = true;
          }
        }
        if (heading && !heading.textContent.trim()) setText(heading, 'Google review');
        root.setAttribute('data-has-google', 'true');
      } else {
        if (block) block.hidden = true;
        if (formWrap) formWrap.hidden = false;
        if (missing) missing.hidden = true;
        root.setAttribute('data-has-google', 'false');
      }
    });

    document.querySelectorAll('[data-minnies-google-footer]').forEach(function (el) {
      if (googleUrl) {
        setHref(el, googleUrl);
        setText(el, label);
        el.hidden = false;
        el.setAttribute('target', '_blank');
        el.setAttribute('rel', 'noopener noreferrer');
      } else {
        /* Keep a reviews-page fallback so footer still has a review path */
        var fallback = el.getAttribute('data-fallback-href') || '/pages/reviews';
        setHref(el, fallback);
        setText(el, label || 'Leave a Review');
        el.removeAttribute('target');
        el.removeAttribute('rel');
        el.hidden = false;
      }
    });
  }

  function starsHtml(rating) {
    var n = Math.max(0, Math.min(5, Number(rating) || 0));
    var html = '';
    for (var i = 1; i <= 5; i++) {
      html +=
        '<span class="testimonial-rating__star' +
        (i <= n ? ' is-filled' : '') +
        '" aria-hidden="true">★</span>';
    }
    return html;
  }

  function applyTestimonials(settings) {
    var roots = document.querySelectorAll('[data-minnies-testimonials]');
    if (!roots.length) return;

    var heading = (settings && settings.testimonials_heading) || '';
    var quotes = Array.isArray(settings && settings.testimonials) ? settings.testimonials : [];

    roots.forEach(function (root) {
      var headingEl = root.querySelector('[data-minnies-testimonials-heading]');
      if (headingEl && heading) setText(headingEl, heading);

      var items = root.querySelectorAll('[data-minnies-testimonial]');
      items.forEach(function (item, index) {
        var quote = quotes[index];
        if (!quote || (!quote.author && !quote.text)) {
          item.hidden = true;
          return;
        }
        item.hidden = false;

        var ratingEl = item.querySelector('[data-minnies-testimonial-rating]');
        if (ratingEl) {
          var rating = Number(quote.rating);
          if (!Number.isFinite(rating) || rating <= 0) {
            ratingEl.hidden = true;
          } else {
            ratingEl.hidden = false;
            ratingEl.setAttribute('aria-label', rating + ' out of 5 stars');
            ratingEl.innerHTML = starsHtml(rating);
          }
        }

        var authorEl = item.querySelector('[data-minnies-testimonial-author]');
        if (authorEl) setText(authorEl, quote.author || '');

        var textEl = item.querySelector('[data-minnies-testimonial-text]');
        if (textEl) {
          textEl.textContent = '';
          if (quote.text) {
            var p = document.createElement('p');
            p.textContent = quote.text;
            textEl.appendChild(p);
          }
        }
      });
    });
  }

  function apply(settings) {
    if (!settings) return;

    document.querySelectorAll('[data-minnies-phone]').forEach(function (el) {
      if (settings.phone) {
        setText(el, settings.phone);
        if (el.tagName === 'A') setHref(el, phoneHref(settings.phone));
      }
    });

    document.querySelectorAll('[data-minnies-email]').forEach(function (el) {
      if (settings.email) {
        setText(el, settings.email);
        if (el.tagName === 'A') setHref(el, 'mailto:' + settings.email);
      }
    });

    document.querySelectorAll('[data-minnies-area]').forEach(function (el) {
      if (settings.service_area) setText(el, settings.service_area);
    });

    document.querySelectorAll('[data-minnies-address-wrap]').forEach(function (wrap) {
      var addr = wrap.querySelector('[data-minnies-address]');
      if (settings.address) {
        wrap.hidden = false;
        if (addr) setText(addr, settings.address);
      } else {
        wrap.hidden = true;
      }
    });

    document.querySelectorAll('[data-minnies-hours-wrap]').forEach(function (wrap) {
      var hoursEl = wrap.querySelector('[data-minnies-hours]');
      if (settings.hours) {
        wrap.hidden = false;
        if (hoursEl) setText(hoursEl, settings.hours);
      } else {
        wrap.hidden = true;
      }
    });

    document.querySelectorAll('[data-minnies-hours]').forEach(function (el) {
      if (el.closest('[data-minnies-hours-wrap]')) return;
      if (settings.hours) {
        el.hidden = false;
        setText(el, settings.hours);
      } else {
        el.hidden = true;
      }
    });

    document.querySelectorAll('[data-minnies-instagram]').forEach(function (el) {
      setSocial(el, settings.social_instagram);
    });
    document.querySelectorAll('[data-minnies-facebook]').forEach(function (el) {
      setSocial(el, settings.social_facebook);
    });
    document.querySelectorAll('[data-minnies-tiktok]').forEach(function (el) {
      setSocial(el, settings.social_tiktok);
    });
    document.querySelectorAll('[data-minnies-youtube]').forEach(function (el) {
      setSocial(el, settings.social_youtube);
    });

    document.querySelectorAll('[data-minnies-follow]').forEach(syncSocialBreaks);

    applyReviewMode(settings);
    applyTestimonials(settings);
  }

  fetch(ENDPOINT + '?t=' + Date.now(), {
    credentials: 'omit',
    mode: 'cors',
    cache: 'no-store',
  })
    .then(function (res) {
      return res.ok ? res.json() : null;
    })
    .then(function (data) {
      if (data && data.settings) apply(data.settings);
    })
    .catch(function () {});
})();
